quoteModule.factory('rateQuoteRetrievalCoordService', ['$http','$window', 'AppSettings','CustomerInfo','DealInfo','VehicleInfo','commonRESTCallService',
    'erateSessionVarsService','imSessionVarsService','$q','rateQuoteCoordService','rateQuoteScenariosService','rateProductCacheService',
    'vehicleProductCoordService','AppSettings', 'rateQuotePersistService','commonTLCService',
    function ($http, $window, appSettings, CustomerInfo,DealInfo, VehicleInfo,  commonRESTCallService,
              erateSessionVarsSvc,imSessionVarsService,$q, rateQuoteCoordService, rateQuoteScenariosService,rateProductCacheService,
              vehicleProductCoordService, AppSettings, rateQuotePersistService, commonTLCService) {

        var rateQuoteRetrievalCoordService = {};

        var _inQuoteRetrieval = false;

        rateQuoteRetrievalCoordService.startQuoteRetrieval = function(){
            $window.sessionStorage.setItem('SESS_IN_QUOTE_RETRIEVE','true');
        }

        rateQuoteRetrievalCoordService.inQuoteRetrieval = function() {
            var val = $window.sessionStorage.getItem('SESS_IN_QUOTE_RETRIEVE');
            return val && val == 'true';
        }

        rateQuoteRetrievalCoordService.endQuoteRetrieval = function() {
            $window.sessionStorage.setItem('SESS_IN_QUOTE_RETRIEVE','false');
        }

        rateQuoteRetrievalCoordService.loadQuoteById = function(quoteid){
            var deferred = $q.defer();

            var url = AppSettings.startSPANPlusSvcURL + "productquotes/" + quoteid;

            //remove the quote
            commonRESTCallService.getFromServer(url)
                .success(function (data, status) {
                    deferred.resolve(data)
                })
                .error(function (data, status) {
                    if (status == "404")
                        deferred.resolve(null);
                    else {
                        deferred.reject(Error(status + ' ' + data));
                    }
                });

            return deferred.promise;
        }

        rateQuoteRetrievalCoordService.getSavedQuoteProducts = function() {
            var currentScenario = rateQuoteScenariosService.getCurrentScenario();
            var cachedProductId = null;
            if (rateQuoteCoordService.getRatesForScenarioCode(currentScenario) && rateQuoteCoordService.getRatesForScenarioCode(currentScenario).length > 0)
                cachedProductId = rateQuoteCoordService.getRatesForScenarioCode(currentScenario)[0].cachedProductResponseId;

            if (cachedProductId){
                return rateProductCacheService.getCachedProductsForCacheId(cachedProductId);
            } else {
                var deferred = $q.defer();
                deferred.reject("No cached ");
                return deferred.promise;
            }
        };

        //load quotes for a quoting session
        rateQuoteRetrievalCoordService.loadQuotesBySessionId = function(sessionID){
            var deferred = $q.defer();

            _inQuoteRetrieval = true;

            var url = appSettings.startSPANRatePersistURL + "/GetQuotesBySessionId/" + imSessionVarsService.getCurrentProviderCode() +
                "/" +  erateSessionVarsSvc.getCurrentDealerAccountCode() + "/" + sessionID;

            //remove the quote
            commonRESTCallService.getFromServer(url)
                .success(function (data, status) {
                    //we need to load all the scenarios and quotes
                    var quotes = data.SavedRates;

                    rateQuoteCoordService.setQuoteSessionId(data.quoteSessionId);

                    var reRetrieveProducts = true;
                    rateQuoteScenariosService.initScenariosForRetrieval();
                    var i = 0;
                    var scenarioCur = 0;
                    quotes.forEach(function(quote){
                        if (scenarioCur == 0)
                            scenarioCur = parseInt(quote.RatedTerms[0].SavedRateScenarioId);

                        if (rateQuoteScenariosService.getScenarioList().indexOf(parseInt(quote.RatedTerms[0].SavedRateScenarioId)) < 0){
                            rateQuoteScenariosService.addNewScenarioNoCopy(parseInt(quote.RatedTerms[0].SavedRateScenarioId));
                            rateQuoteCoordService.getHeldQuotesPerProposal()[parseInt(quote.RatedTerms[0].SavedRateScenarioId)] = [];
                        }
                        //holding on to the cached product and rate result.. for retrieval later
                        if (data.CachedProductResponseIds && data.CachedProductResponseIds[i])
                            quote.cachedProductResponseId = data.CachedProductResponseIds[i];
                        if (data.CachedRateResponseIds && data.CachedRateResponseIds[i])
                            quote.cachedRateResponseId = data.CachedRateResponseIds[i];
                        rateQuoteCoordService.holdRateForQuote(quote,parseInt(quote.RatedTerms[0].SavedRateScenarioId),quote.cachedProductResponseId,quote.cachedRateResponseId);
                        i = i + 1;
                    });

                    rateQuoteScenariosService.setCurrentScenario(scenarioCur);
                    //customer data back
                    rateQuoteCoordService.CustomerData = null;
                    rateQuoteCoordService.CustomerData = new CustomerInfo();
                    rateQuoteCoordService.CustomerData.consumeFromRateQuoteRetrieve(data.customerInformation);
                    //vehicle data back
                    rateQuoteCoordService.VehicleData = null;
                    rateQuoteCoordService.VehicleData = new VehicleInfo();
                    rateQuoteCoordService.VehicleData.consumeFromRateQuoteRetrieve(data.vehicleToRate,data.partnerSpecificFields);
                    rateQuoteCoordService.VehicleData.odometer = data.vehicleOdometer;
                    rateQuoteCoordService.VehicleData.dateOfSale = new Date(data.dateOfSale);
                    rateQuoteCoordService.VehicleData.vehicleCert = data.vehicleCertification;
                    if(data.vehicleInservice) {
                        rateQuoteCoordService.VehicleData.inService = new Date(data.vehicleInservice);
                    }
                    if (data.vehicleUsageTypes){
                        rateQuoteCoordService.VehicleData.vehicleUsage = data.vehicleUsageTypes.join(',');
                    }
                    //deal data back
                    rateQuoteCoordService.DealData = null;
                    rateQuoteCoordService.DealData = new DealInfo();
                    rateQuoteCoordService.DealData.consumeFromRateQuoteRetrieve(data.vehicleFinancials);
                    //keep alternate field for original deal details
                    rateQuoteCoordService.RetrievedDealData = new DealInfo();
                    rateQuoteCoordService.RetrievedDealData.consumeFromRateQuoteRetrieve(data.vehicleFinancials);
                    if(data.partnerSpecificFields) {
                        rateQuoteCoordService.LenderData.selectedLender.consumeFromRateQuoteRetrieve(data.partnerSpecificFields);
                    }

                    if (!(data.EncodedQuoteNums && data.EncodedQuoteNums.length > 0)) {
                        var encPromises = quotes.map(function (nxtQuote) {
                            return commonTLCService.encryptNumeric(nxtQuote.RatedTerms[0].SavedRateUniqueId);
                        });

                        $q.all(encPromises)
                            .then(function (encodedIds) {
                                for (var i = 0; i < encodedIds.length; i++) {
                                    rateQuotePersistService.setEncryptedQuoteId(quotes[i].RatedTerms[0].SavedRateUniqueId, encodedIds[i]);
                                }

                                rateQuoteScenariosService.setCurrentScenario(scenarioCur);

                                data = null;
                                quotes = null;
                                deferred.resolve(true); //done setting up values
                            });
                    }else{
                        for (var i = 0; i < data.EncodedQuoteNums.length; i++) {
                            rateQuotePersistService.setEncryptedQuoteId(data.SavedRates[i].RatedTerms[0].SavedRateUniqueId,data.EncodedQuoteNums[i]);
                        }
                        rateQuoteScenariosService.setCurrentScenario(scenarioCur);

                        data = null;
                        quotes = null;
                        deferred.resolve(true); //done setting up values
                    }
                })
                .error(function (data, status) {
                    if (status == "404")
                        deferred.reject(Error("Quote not found"));
                    else {
                        deferred.reject(Error(status + ' ' + data));
                    }
                });

            return deferred.promise;
        }

        // Parses a date in either mm/dd/yyyy or mm-dd-yyyy format
        function parseMmDdYyyy(date) {
            var splitOn = date.indexOf('/') >= 0 ? '/' : '-';
            var dateSplit = date.split(splitOn);
            return new Date(parseInt(dateSplit[2]),parseInt(dateSplit[0])-1,parseInt(dateSplit[1]));
        }

        return rateQuoteRetrievalCoordService;
    }]);
